import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import api from '../sever/Api';
import logo1 from '../assets/new-Logo.png';
import logo from '../assets/logo PNG Transparent/Logo-08.png'
import mailFrame from '../assets/login email.png';
import lockFrame from '../assets/login password.png';
import textlogo from '../assets/UnlockYourPotential.png';
import esscoBg from '../assets/essco-bg.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Get the page user was trying to access before login
  const from = location.state?.from || '/sevenquestion';

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please fill in all fields");
      return;
    }
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return;
    }

    setIsLoading(true);

    try {
      console.log("Making API call to /api/auth/login");
      const { data } = await api.post("/api/auth/login", { email, password });

      console.log("Login API Response:", data);

      console.log("User Role:", data.user?.role);

      if (data.token && data.user) {
        login(data.token, data.user, data.user._id || data.user.id);

        if (data.user?.role === "admin") {
          console.log("✅ This user is an ADMIN");
        } else {
          console.log("👤 This user is a normal USER");
        }

        toast.success("Login successful! Welcome back!");

        // Check if this is a first-time user
        const isFirstTimeUser = localStorage.getItem('isFirstTimeUser');
        
        setTimeout(() => {
          if (isFirstTimeUser === '1') {
            // Clear the flag and redirect to SevenQuestion for first-time users
            localStorage.removeItem('isFirstTimeUser');
            navigate('/sevenquestion', { replace: true });
          } else {
            // Regular users go to their intended destination
            navigate(from, { replace: true });
          }
        }, 1200);
      } else {
        toast.error("Invalid response from server");
      }
    } catch (error) {
      console.error("Login Error:", error);

      const status = error?.response?.status;
      const serverMessage = error?.response?.data?.message;

      if (status === 400 || status === 401 || status === 404) {
        toast.error("Invalid email or password");
        // setTimeout(() => {
        //   navigate("/dashboard", { replace: true });
        // }, 2000);
      } else if (serverMessage) {
        toast.error(serverMessage);
      } else if (error?.message?.toLowerCase().includes("network")) {
        toast.error("Network error. Please try again.");
      } else {
        toast.error("Login failed. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className=' min-h-screen bg-[linear-gradient(126.39deg,#F7F6FA_5.58%,#F5F4FC_27.79%,#F2F2FE_48.29%,#F5F4FF_69.65%,#FFF9FF_94.42%)]' style={{
        backgroundImage: `url(${esscoBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className="flex flex-row justify-center items-center px-[32px] py-[16px] bg-[rgba(247,248,250,0.01)] shadow-[0px_2px_7px_rgba(0,0,0,0.07)]" >
          <img src={logo1} alt="HWORK2 Logo" style={{ width: 215, height: 41 }} />
        </div>
        <div className="mt-6 w-full overflow-x-hidden flex items-center justify-center ">


          {/* Main Login Card */}
          <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
            {/* Card Header */}
            <div className="text-center mb-8">
              <div className=" flex items-center justify-center mx-auto mb-4 relative" style={{ width: 123 }}>
                <img src={logo} alt="HWORK2 Logo" className="w-full h-full" />


              </div>
              <h1 className="font-semibold text-[24px] leading-[32px] text-center text-[#151417] mb-2" style={{ fontFamily: 'Lato, sans-serif' }}>The HWORK2 Method</h1>
              {/* <p className="text-purple-600 italic"style={{fontFamily: 'Playfair Display, serif', fontSize:32}}>Unlock Your Potential</p> */}
              <img src={textlogo} alt="HWORK2 Logo" className="w-full h-full" />
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                <div className="flex items-center border border-gray-300 rounded-lg px-3 py-3 focus-within:border-purple-500 transition">
                  <img src={mailFrame} alt="email" className="w-4 h-4 mr-3 text-gray-400" />
                  <input
                    type="email"
                    placeholder="name@mail.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className="flex-1 bg-transparent outline-none text-gray-800 placeholder-gray-400"
                    required
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
                <div className="flex items-center border border-gray-300 rounded-lg px-3 py-3 focus-within:border-purple-500 transition">
                  <img src={lockFrame} alt="lock" className="w-4 h-4 mr-3 text-gray-400" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="••••••••••"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    className="flex-1 bg-transparent outline-none text-gray-800 placeholder-gray-400"
                    required
                    disabled={isLoading}
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="ml-2 p-1 rounded-full hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-purple-300"
                    title={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? (
                      // Eye closed icon (password hidden)
                      <svg
                        className="w-5 h-5 text-gray-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                        />
                      </svg>
                    ) : (
                      // Eye open icon (password visible)
                      <svg
                        className="w-5 h-5 text-gray-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                <div className="flex justify-end">
                <Link to="/forgotpassword" className="text-[12px] text-gray-600 ">Forgot Password</Link>
                </div>
              </div>
              <button
                type="submit"
                disabled={isLoading}
                className={`w-full py-3 rounded-lg bg-[#7A81FF] text-white font-semibold ${isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:from-purple-600 hover:to-purple-800'
                  }`}
              >
                {isLoading ? 'Logging in...' : 'Sign In'}
              </button>


              <p className="text-center text-[18px] text-gray-600">
                FIRST TIME USER? <Link to="/register" className="text-[#7A81FF] underline hover:text-purple-800">SIGN UP HERE NOW</Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login; 